import React from "react";
import "./Aug_2026.scss";

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="effective-date">
          <strong>Effective Date:</strong> August 9, 2026
        </p>

        <p>
          Welcome to <strong>Banke Store</strong> ("Banke", "we", "our", or
          "us"). This Privacy Policy explains how we collect, use, disclose, and
          protect your information when you use the Banke website, Android
          application, iOS application, and any related services we provide
          (collectively, the "Services").
        </p>

        <p>
          By using our Services, you agree to the practices described in this
          Privacy Policy.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Mobile phone number</li>
          <li>Delivery and billing addresses</li>
          <li>Order history and purchase records</li>
          <li>Payment transaction references</li>
          <li>
            Device information (device type, operating system, app version)
          </li>
          <li>IP address and browser information</li>
          <li>Customer support communications</li>
          <li>Usage and analytics information</li>
        </ul>

        <h2>2. Google Sign-In</h2>
        <p>
          If you choose to sign in with your Google account, Banke receives
          information from Google such as your name, email address, and a Google
          account identifier. We use this information solely to authenticate
          your account, create or link your Banke account, and provide our
          Services. We do not receive or store your Google account password.
        </p>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>Create and manage your account</li>
          <li>Authenticate your identity</li>
          <li>Process and fulfill orders</li>
          <li>Coordinate deliveries</li>
          <li>Facilitate transactions between customers and vendors</li>
          <li>Provide customer support</li>
          <li>Prevent fraud and unauthorized access</li>
          <li>Comply with legal and regulatory obligations</li>
          <li>Improve our Services and user experience</li>
          <li>Send important account, order, and security notifications</li>
        </ul>

        <h2>4. Marketplace and Vendor Operations</h2>
        <p>
          Banke operates as a marketplace connecting customers with independent
          vendors. When you place an order, relevant order information may be
          shared with the vendor responsible for fulfilling that order,
          including your name, delivery address, phone number, and order
          details.
        </p>

        <h2>5. Payments</h2>
        <p>
          Payments made through Banke are processed by trusted third-party
          payment providers. Banke does not store your full payment card details
          on our servers.
        </p>

        <h2>6. Mobile App Permissions</h2>
        <ul>
          <li>Internet access</li>
          <li>Push notifications</li>
          <li>Camera (if you choose to upload images)</li>
          <li>Photo library (if you choose to upload images)</li>
          <li>
            Device identifiers necessary for authentication and app
            functionality
          </li>
        </ul>

        <h2>7. Cookies and Similar Technologies</h2>
        <p>
          Our website may use cookies and similar technologies to remember
          preferences, improve functionality, analyze traffic, and enhance your
          experience.
        </p>

        <h2>8. How We Share Your Information</h2>
        <ul>
          <li>Vendors fulfilling your orders</li>
          <li>Payment processing providers</li>
          <li>Delivery and logistics partners</li>
          <li>Cloud hosting and infrastructure providers</li>
          <li>Analytics and security service providers</li>
          <li>Government or regulatory authorities where required by law</li>
        </ul>
        <p>We do not sell your personal information to third parties.</p>

        <h2>9. Data Security</h2>
        <p>
          We implement appropriate technical and organizational measures to
          protect your personal information against unauthorized access,
          alteration, disclosure, or destruction.
        </p>

        <h2>10. Data Retention</h2>
        <p>
          We retain your information for as long as necessary to provide our
          Services, comply with legal obligations, resolve disputes, enforce our
          agreements, and maintain business records.
        </p>

        <h2>11. Your Rights</h2>
        <ul>
          <li>Access your personal information</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your information</li>
          <li>Close your account</li>
          <li>Withdraw consent where applicable</li>
          <li>Request information about how your data is used</li>
        </ul>

        <h2>12. Children's Privacy</h2>
        <p>
          Banke is not intended for children under the age of 13. We do not
          knowingly collect personal information from children under 13.
        </p>

        <h2>13. International Transfers</h2>
        <p>
          Your information may be processed and stored on servers located
          outside Nigeria where our service providers operate.
        </p>

        <h2>14. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Continued use of
          our Services after changes become effective constitutes acceptance of
          the updated policy.
        </p>

        <h2>15. Contact Us</h2>
        <p>
          <strong>Banke Store</strong>
          <br />
          Lagos, Nigeria
          <br />
          Email: support@banke.com.ng
          <br />
          Website: https://banke.com.ng
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
